pxco.Toogle = function (btn, options) {
	options = typeof options !== 'undefined' ? options : {};

	var me = pxco.extend({
		prefix: 'pxToggle',
		target: btn,
		dataToggle: btn.getAttribute('data-toggle'),
		dataToggleOut: btn.getAttribute('data-toggle-out')
	}, options);

	if (!me.dataToggle && !me.target)
		return false;

	me.el = btn;
	me.target = me.dataToggle ? document.querySelector(me.dataToggle) : me.target;
	me.className = btn.getAttribute('data-toggle-class') ? btn.getAttribute('data-toggle-class') : 'toggled';
	me.elClickOutside = document.querySelector(me.dataToggleOut);
	me.state = me.prefix + ':off';

	btn.onclick = function (e) {
		e.preventDefault();
		me.target.classList.toggle(me.className);
		me.state = me.target.classList.contains(me.className) ? me.prefix + ':on' : me.prefix + ':off';
	}

	if (me.elClickOutside) {
		document.onclick = function (event) {
			if (me.state == me.prefix + ':on' && me.elClickOutside !== event.target && !me.elClickOutside.contains(event.target) && btn !== event.target) {
				me.target.classList.remove(me.className);

				me.state = me.prefix + ':off';
			}
		};
	}

	pxco.events.set(me, me.state);

	return me;
};

var pxcoToogle = document.querySelectorAll('[data-toggle]');
for (var x = 0; x < pxcoToogle.length; x++) {
	var toggle = new pxco.Toogle(pxcoToogle[x]);
}